module.exports = __webpack_public_path__ + "static/img/RE2.7991366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE2.jpg
// module id = wxMB
// module chunks = 0